export interface CurrencyCodes {
  responseData: {
    currency_list: [];
  };
}
